import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineChargePaymentDescription のスタイル
 */
export const hotlineChargePaymentDescriptionStyle = tv({
    slots: {
        base: ['flex flex-col gap-8 lg:gap-16', 'p-16', 'rounded-md', 'w-full'],
        item: [textStyle({ color: 'base', size: 'sm' }), 'whitespace-pre-line'],
        list: ['flex flex-col gap-2', 'list-disc', 'pl-20'],
        title: [textStyle({ color: 'base', isBold: true, size: 'sm' })],
    },
    variants: {
        color: {
            orange: {
                base: ['bg-orange-50'],
            },
            white: {
                base: ['bg-gray-50'],
            },
        },
    },
});
